/**
 * home.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component } from "@angular/core";
import { AlgorithmService } from "app/algorithms/management/algorithm.service";
import { ConfigurationService } from "app/configuration/configuration.service";
import { SubjectService } from "app/subjects/subject.service";

@Component({
  template: `
    <div class="container">
      <div class="row"><div class="col-sm-12">
        <announcements></announcements>
      </div></div>
      <div class="row">
        <div [className]="config.client.type === 'guest' ? 'col-sm-6' : 'col-sm-4'">
          <user-profile></user-profile>
        </div>

        <div *ngIf="config.client.type !== 'guest'" class="col-sm-8">
          <reminder-list [showHeaders]="false"></reminder-list>
        </div>

        <div *ngIf="config.client.type !== 'guest'" class="col-sm-12">
          <watchlist></watchlist>
        </div>

        <div *ngIf="config.client.type === 'guest'" class="col-sm-6" style="display: flex; flex-direction: column; min-height: 350px;justify-content: center;">
          <div class="well">
            <h4>Looking for the form?</h4>
            <p>You can access the intake form by clicking the "Restart" button in the navigation bar, or use the one below.</p>
            <button class="w100 btn btn-success" (click)="startDefault()">
              Start New intake
            </button>
          </div>
        </div>
      </div>
    </div>
`,
  styles: [``]
})
export class HomeComponent {
  constructor(
    protected config : ConfigurationService,
    protected subjects : SubjectService,
    protected algorithms : AlgorithmService
  ) {}

  startDefault() {
    this.subjects.launchNew(this.algorithms.createable[0]);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/watchlist/home.component.ts